export default __webpack_public_path__ + "static/media/signin.f65ae0e2.png";